export default __webpack_public_path__ + "static/media/eyeball.a4ed9b50.svg";